import { render, staticRenderFns } from "./Ramais.vue?vue&type=template&id=4c61cf34&"
import script from "./Ramais.vue?vue&type=script&lang=js&"
export * from "./Ramais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports